
import commonCss from "./code/css.js"
import http from "./code/http.js"

export default {
    "fangzhou": [{
        label: '脚本',
        desc: "用于备份方舟组件的脚本",
        titles: ["脚本"],
        imgs: ["theScript.png"],
        codes: [],
        children:[]
    },{
        label: 'common',
        children:[{
            label: "css",
            desc: "存放公共的css样式,如：占位图样式、滚动条样式、分页器样式等",
            titles: ["common","css"],
            imgs: ["css.png"],
            codes: [{
                title: "",
                code: commonCss
            }],
            children:[]
        },{
            label: "images",
            desc: "存放公共的图片",
            titles: ["common","images"],
            imgs: [],
            codes: [],
            children:[]
        },{
            label: "js",
            desc: "存放公共的全局方法",
            titles: ["common","js"],
            imgs: ["js.png"],
            codes: [],
            children:[]
        }]
    },{
        label: 'components',
        desc: "存放公共组件，如基于element-ui二次封装的组件或自己封装的多个组件会引用的组件，如：级联筛选器、时间选择器",
        titles: ["components"],
        imgs: ["components.png"],
        codes: [],
        children:[]
    },{
        label: 'http',
        children:[{
            label: 'api.js',
            desc: "全局api地址",
            titles: ["http","api.js"],
            imgs: ["api.png"],
            codes: [],
            children:[]
        },{
            label: 'index.js',
            desc: "基于方舟 $proxy 封装的请求方法，供全局调用",
            titles: ["http","index.js"],
            imgs: ["http.png"],
            codes: [{
                title:"",
                code: http
            }],
            children:[]
        }]
    },{
        label: 'mixins',
        children:[{
            label: 'mixins.js',
            desc: "全局共享的数据和方法",
            titles: ["mixins","mixins.js"],
            imgs: ["mixins.png"],
            codes: [],
            children:[]
        }]
    },{
        label: 'pages',
        desc: "存放不同菜单下的自定义组件",
        titles: ["pages"],
        imgs: ["pages.png"],
        codes: [],
        children:[]
    }]
}


// WEBPACK FOOTER //
// ./src/pages/frontProJect/menuData.js